import { render, staticRenderFns } from "./PlpProducts21.vue?vue&type=template&id=94744206&scoped=true"
import script from "./PlpProducts21.vue?vue&type=script&lang=js"
export * from "./PlpProducts21.vue?vue&type=script&lang=js"
import style0 from "./PlpProducts21.vue?vue&type=style&index=0&id=94744206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94744206",
  null
  
)

export default component.exports